<div class="error">
  <div class="body-error d-flex flex-column position-relative">
    <div class="logo-error">
      <i class="fa fa-exclamation-triangle"></i>
    </div>
    <div class="type-error">
      Erreur dans l'application
    </div>
    <div class="type-error" *ngIf="errorUrl !== ''">
      URL: <strong>{{errorUrl}}</strong>
    </div>
    <div class="message-error d-flex flex-column justify-content-center text-center">{{errorMessage}}</div>
    <div class="d-flex flex-column justify-content-center text-center mt-3">
      <strong>Solution proposée :</strong>
      Veuillez vider le cache de votre navigateur et reconnectez-vous. <br />
      Si le problème persiste, merci de vous rapprocher du service technique
    </div>
    <!--<div class="button-contact w-100 d-flex flex-row justify-content-center position-absolute">
    <button *ngIf="dataError.noerror && !messageSend" class="btn q-b-selected" (click)="contactSupport()">Contactez le support</button>
    <div *ngIf="dataError.noerror && messageSend" class="alert alert-success">Votre message a bien été envoyé, contactez le support au 04-44-44-44-44</div>
    <div *ngIf="!dataError.noerror" class="alert alert-success">
    L'envoi automatique n'a pas fonctionné<br/>
    Une fois votre message envoyé, contactez le support au 04-67-27-12-03</div>
  </div>-->
  </div>
</div>
